import { PostEdit } from "./PostEdit.js";
import { WpUser } from "./WpUser.js";

export interface ProfilerStackItem {
    start: number;
    key: string;
    action: "start" | "stop";
}

export class Plugins {
    constructor() {

        if (e5.Plugins.blocks) {
            console.warn("e5.Plugins is already defined.");
            return;
        }

        Object.defineProperty(window, 'tools', {
            enumerable: false,
            configurable: true,
            get: () => {
                console.warn("Deprecated: window.tools is deprecated. Use e5.Plugins instead.");
                return e5.Plugins;
            }
        });

        Object.defineProperty(e5.Plugins, 'debug', {
            enumerable: false,
            configurable: true,
            get: () => {
                console.warn("Deprecated: window.tools.debug is deprecated. Use e5.Debug instead.");
                return e5.Debug;
            }
        });

        e5.Plugins.active = (uid: string) => {
            console.warn("Deprecated: window.tools.active() is deprecated. Use e5.Debug.active() instead.");
            return e5.Debug.active(uid);
        };

        let meta = document.querySelector(`meta[name="e5-meta-config"]`) as HTMLElement;
        if (!meta && window.top !== window.self) {
            try {
                meta = window.top.document.querySelector(`meta[name="e5-meta-config"]`) as HTMLElement;
                if (!meta) {
                    throw new Error(`Missing meta tag in window.top: meta[name="e5-meta-config"]`);
                }
            } catch (error) {
                console.error(error);
                return;
            }
        }

        if (!meta) {
            console.error("Missing meta tag:", `meta[name="e5-meta-config"]`);
            return;
        }

        try {
            e5.Plugins.config = JSON.parse(meta.getAttribute("data-json"));
        } catch (error) {
            e5.Plugins.config = {} as any;
            console.error("Could not parse meta config json", error);
            return;
        }

        if (e5.Plugins.config.language) {
            e5.lang.current = e5.Plugins.config.language;
        }

        if (e5.Plugins.config.dictionary) {
            e5.dict.add(e5.Plugins.config.dictionary);
        }

        if (e5.Plugins.config.isLocalReal) {
            e5.Debug.add({
                uid: "e5-force-not-local",
                icon: "fal fa-arrows-split-up-and-left",
                tooltip: "Disable Local Detection",
                cookie: true
            });
        }

        if (
            e5.Plugins.config.isLocal
            && e5.Plugins.config.realeaseUrl) {
            const realeaseUrl = e5.Text.rtrim(e5.Plugins.config.realeaseUrl, "/");
            const siteUrl = e5.Text.rtrim(e5.Plugins.config.siteUrl, "/");
            e5.Debug.add({
                uid: "release-url",
                icon: "fal fa-globe",
                tooltip: "Release URL",
                url: window.location.href.replace(siteUrl, realeaseUrl)
            });
        }

        if (!document.body.classList.contains("block-editor-page")) {

            const sizes = [
                {
                    name: "Mobile",
                    bp: "mobile",
                },
                {
                    name: "Tablet",
                    bp: "tablet"
                },
                {
                    name: "Landscape",
                    bp: "landscape"
                },
                {
                    name: "Desktop",
                    bp: "desktop"
                },
                {
                    name: "XS",
                    bp: "xs",
                    prefix: " | "
                },
                {
                    name: "S",
                    bp: "s",
                    prefix: " | "
                },
                {
                    name: "M",
                    bp: "m",
                    prefix: " | "
                },
                {
                    name: "L",
                    bp: "l",
                    prefix: " | "
                },
                {
                    name: "XL",
                    bp: "xl",
                    prefix: " | "
                },
                {
                    name: "XXL",
                    bp: "xxl",
                    prefix: " | "
                }
            ];

            e5.Debug.add({
                uid: "e5-responsive-view",
                tooltip: "Responsive View",
                label: "",
                html: sizes.map((size) => {
                    return `<span class="e5-visible--${size.bp}">${size.prefix || ""}${size.name}</span>`;
                }).join(""),
            });
        }

        e5.Plugins.blocks = {};

        e5.console.enabled = e5.Plugins.config.isDebugging;
        console.log("[eventfive.wordpress-plugin] [Plugins]");
        e5.Debug.visible = e5.Plugins.config.isDebugging;

        e5.Plugins.user = new WpUser();


        // if (e5.Plugins.config?.profiler?.length > 0
        // ) 
        {
            e5.Debug.remove("profile");

            const nav = window.performance.getEntriesByType("navigation");
            let label = "";
            if (nav && nav.length > 0) {
                const v: any = nav[0];
                const val = ((v.responseStart - v.requestStart) / 1000);
                label = isNaN(val) ? '?' : val.toFixed(2);
            }

            e5.Debug.add({
                uid: "e5-wp-profiler",
                icon: "fal fa-stopwatch",
                cookie: true,
                tooltip: "Profiler",
                label: label,
                windows: [
                    {
                        onInit: (win) => {
                            const stack: ProfilerStackItem[] = e5.Plugins.config?.profiler;

                            if (!stack || stack.length === 0) {
                                return;
                            }

                            const lookup: { [key: string]: ProfilerStackItem } = {};
                            const items: { key: string; duration: number; nesting: number; }[] = [];
                            let nesting = 0;
                            stack.forEach((item) => {
                                if (item.action === "start") {
                                    lookup[item.key] = item;
                                    nesting++;
                                } else {
                                    const start = lookup[item.key];
                                    if (start) {
                                        items.push({
                                            key: item.key,
                                            duration: item.start - start.start,
                                            nesting: nesting
                                        });
                                        nesting--;
                                    }
                                }
                            });

                            let html = `<div class="e5-profiler">`;
                            html += `<table>`;
                            html += `<thead><tr><th>Key</th><th>Duration</th></tr></thead>`;
                            html += `<tbody>`;
                            items.forEach((item) => {
                                html += `<tr><td>${item.key}</td><td>${(item.duration * 1000).toFixed(2) + " ms"}</td></tr>`;
                            });
                            html += `</tbody>`;
                            html += `</table>`;
                            html += `</div>`;

                            win.html = html;
                        }
                    }
                ]
            });
        }

        if (e5.Plugins.config?.editPostLink
            && !e5.Plugins.config?.isAdmin
        ) {
            e5.Debug.add({
                uid: "edit-current-post",
                icon: "fal fa-pen",
                tooltip: "Edit Post",
                url: e5.Plugins.config.editPostLink
            });
        }

        //TODO: add it to eventfive settings page
        if (e5.Plugins.config?.disableCssTransitionOnResize
            && !e5.Plugins.config?.isAdmin
        ) {
            let t: any = null;
            window.addEventListener("resize", () => {
                document.body.classList.add("e5-disable-transition");
                clearTimeout(t);
                t = setTimeout(() => {
                    document.body.classList.remove("e5-disable-transition");
                });
            });
        }

        if (e5.Plugins.config?.isDebugging
            && !e5.Plugins.config?.isAdmin
            && e5.Plugins.config?.editPostInfo) {
            e5.Debug.add({
                uid: "e5-edit-post",
                icon: "fal fa-pen-to-square",
                tooltip: "Edit Inline",
                toggle: true,
                localStorage: true,
                onInit: (item) => {
                    let edit: PostEdit = null;
                    const toggle = () => {
                        if (item.active) {
                            edit = new PostEdit();
                        } else if (edit) {
                            edit.dispose();
                            edit = null;
                        }
                    };
                    toggle();

                    item.onToggle.add(toggle);
                }
            });
        }

        window.dispatchEvent(new Event("e5-plugins-ready"));
        window.dispatchEvent(new Event("e5-blocks-ready"));
    }
}